import React from 'react';

function question1 (modules, config, el, msg) {
    console.log('Question1', modules, msg, el)
    el.innerHTML = 'Question 1 <button class = "outcome1">Outcome</button> <button class="question1">Next</button>';
    setTimeout(function() {
        var clickHandler = function() { modules.device.triggerOutcome("final", true) }
        var outcomeHandler = function() { modules.device.triggerOutcome("notFinal") }
        document.getElementsByClassName('question1')[0].removeEventListener('click', clickHandler);
        document.getElementsByClassName('question1')[0].addEventListener('click', clickHandler);
        document.getElementsByClassName('outcome1')[0].addEventListener('click', outcomeHandler);
    }, 1000)
}

function customizeMessage(questionFn, newMsg) {
    return function (modules, config, el, msg) {
        let devicePrototype = Object.getPrototypeOf(modules.device)
        let newGameDevice = Object.create(devicePrototype)
        Object.assign(newGameDevice, modules.device)
        devicePrototype.constructor.call(newGameDevice, newMsg, modules.navigation, newGameDevice.device, newGameDevice.helpers, modules.device.schemeId)

        let newModules = Object.assign({}, modules, { device : newGameDevice } )

        return questionFn(newModules, config, el, newMsg)
    }
}

const config = {
  questions: [
    {
      question: customizeMessage(question1, { systemId : 4321 })
    },
    {
      question: (modules, config, el, msg) => {
        return new Promise((resolve) => {
          console.log('Question2', modules, msg, el)
          el.innerHTML = 'Question 2 <button class="question2">Next</button>';
          setTimeout(function() {
            var clickHandler = function() { modules.device.triggerOutcome({}, modules) }
            document.getElementsByClassName('question2')[0].removeEventListener('click', clickHandler)
            document.getElementsByClassName('question2')[0].addEventListener('click', clickHandler);
          }, 1000)
        })
      }
    }
  ],
  waitForFinalOutcome: false
}

export const game = {
    modules: {
      navigation: {
        next: () => {
          console.log("MAIN NEXT")
        }
       },
      device: {
        gameNavigation: {
          next: () => {

          }
        },
        store: (data) => {
          console.log('DEBUG: device.store', data)
          return Promise.resolve(true)
        },
        unsafeStore: (data) => {
          console.log('DEBUG: device.unsafeStore', data)
          return Promise.resolve(true)
        },
        triggerOutcome: (data, modules) => {
          console.log('DEBUG: device.triggerOutcome', data)    
          game.modules.device.gameNavigation.next()
          return Promise.resolve(true)
        },
        unlock: (data) => {
          console.log('DEBUG: device.unlock', data)
          return Promise.resolve(true)
        },
        services: {
        }      
      }
    },
    config: config,
    message: {
      quantities : {
        closeBeforeFinal : true
      }
    },
    el: 'test-elem'
};
  
const gameContext = React.createContext(game);

export default gameContext;
